<template>
  <div class="page-view box-card">
    <div class="box-card-header">
      <router-link class="kg-btn1" :to="{ name: 'publicDepositRecord' }">
        <I18Lang id="my5" defaultText="入金记录" />
      </router-link>
    </div>
    <div class="box-card-content">
      <el-form
        :model="depositData"
        :rules="rules"
        ref="formData"
        class="reset-from"
      >
        <div class="left">
          <div class="form-item">
            <div class="form-item-label">
              <I18Lang id="my8" defaultText="现金账户" />（MEQ）
            </div>
            <div class="form-item-value">{{ rechargeInfo.balance }}</div>
          </div>

          <el-form-item label="USDT">
            <template slot="label">
              <I18Lang id="my155" defaultText="Tether（USDT）" />
            </template>
            <el-input
              type="number"
              @input="inputNum"
              class="reset-input"
              v-model="depositData.amount"
              :placeholder="$t('text3')"
            ></el-input>
            <p class="rate-text">
              <I18Lang id="my11" defaultText="当前的汇率" />
              <i class="cr-red">{{ rechargeInfo.exchange_rate }}</i>
            </p>
          </el-form-item>

          <div class="form-item">
            <div class="form-item-label">
              <I18Lang id="text1" defaultText="元股（MEQ）" />
            </div>
            <div class="form-item-value">{{ usdMoney }}</div>
          </div>

          <el-form-item label="交易ID" prop="trade_id">
            <template slot="label">
              <I18Lang id="text2" defaultText="交易ID" />
            </template>
            <el-input
              v-model="depositData.trade_id"
              class="reset-input"
              :placeholder="$t('my15')"
              @blur="normalizeTradeId"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <div
              :loading="isSubmitLoading"
              class="btn-submit kg-btn2"
              @click="submitForm('formData')"
            >
              <I18Lang id="my22" defaultText="立即提交" />
            </div>
          </el-form-item>
        </div>

        <div class="right">
          <div class="bank-info">
            <span class="bank-info-title"><I18Lang id="text59" defaultText="钱包地址" /></span>

            <div class="info-item item-radio">
              <el-radio-group v-model="vsType" @change="changeVs">
                <el-radio
                  v-for="(item, idx) in rechargeInfo.usdt_address"
                  :key="idx"
                  :label="item.name"
                >
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </div>

            <div class="info-item">
              <div class="info-item-left">
                <div class="key">{{$t('usermoney65')}}</div>
                <div class="value">{{ currUsdtAddress.address }}</div>
              </div>
              <div
                class="info-item-right kg-btn4 directors-copy1"
                :data-clipboard-text="currUsdtAddress.address"
                @click="copyText('.directors-copy1')"
              >
                {{$t('user38')}}
              </div>
            </div>

            <div class="info-item">
              <div class="info-item-left">
                <div class="key">{{$t('usermoney66')}}</div>
                <div class="value">
                  <img class="code-img" :src="currUsdtAddress.qr_code" alt="" />
                </div>
              </div>
            </div>
          </div>

          <div class="vs-info">
            <div class="title">{{$t('usermoney67')}}</div>
            <div class="desc">
              {{$t('usermoney68')}}
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import { fileDomain } from '@utils'
import { mapState } from 'vuex'
import request from '@utils/request'

export default {
  name: 'home',
  data () {
    const validateTradeId = (rule, value, callback) => {
      const tradeId = String(value || '').trim()

      if (!tradeId) {
        callback(new Error(this.$t('my15')))
        return
      }

      // 交易哈希通常由数字和英文字母组成，例如 0x... 或 TRON TXID。
      // 允许纯数字、纯字母以及数字字母组合，不允许空格和特殊符号。
      if (!/^[A-Za-z0-9]+$/.test(tradeId)) {
        const messageMap = {
          zh: '交易哈希值只能包含英文字母和数字',
          en: 'The transaction hash can only contain English letters and numbers',
          ja: '取引ハッシュ値には半角英字と数字のみ使用できます'
        }
        callback(new Error(messageMap[this.$i18n.locale] || messageMap.en))
        return
      }

      callback()
    }

    return {
      fileDomain,
      isSubmitLoading: false,
      rechargeInfo: {},
      depositData: {
        amount: '',
        exchange_rate: '',
        trade_id: '',
        wallet_type: '',
        wallet_address: ''
      },
      vsType: '',
      currUsdtAddress: {},
      rules: {
        trade_id: [
          { validator: validateTradeId, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  created () {
    this.getRechargeInfo()
  },
  methods: {
    getBit (value, bit = 3) {
      let str = value.toString()
      const strIndex = str.indexOf('.')
      if (strIndex === -1) return str
      str = str.substring(0, strIndex + bit)
      return str
    },
    inputNum () {
      this.depositData.amount = this.depositData.amount.replace(
        // eslint-disable-next-line no-useless-escape
        /^(\-)*(\d+)\.(\d\d).*$/,
        '$1$2.$3'
      )
    },
    changeVs (val) {
      console.log(val)
      this.currUsdtAddress = {}
      if (this.rechargeInfo && this.rechargeInfo.usdt_address) {
        this.currUsdtAddress = this.rechargeInfo.usdt_address.find(
          (item) => item.name === val
        ) || {}
      }
    },
    getRechargeInfo () {
      // 获取转账信息
      this.$http
        .post('/api/cash/rechargeInfo', {}, { direct: true })
        .then((result) => {
          this.rechargeInfo = result.data
          if (
            result.data &&
            result.data.usdt_address &&
            result.data.usdt_address.length
          ) {
            this.vsType = result.data.usdt_address[0].name
            this.currUsdtAddress = result.data.usdt_address[0]
          }
        })
    },
    copyText (val) {
      const cpText = new Clipboard(val)
      cpText.on('success', (e) => {
        this.$alert(this.$t('public27'), {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'success-alert',
          callback: (action) => {}
        })
        cpText.destroy()
      })
    },
    normalizeTradeId () {
      this.depositData.trade_id = String(
        this.depositData.trade_id || ''
      ).trim()
    },
    submitForm (formName) {
      if (this.isSubmitLoading) {
        return false
      }
      this.normalizeTradeId()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitDeposit()
        }
      })
    },
    async checkRechargeVoucherExists (tradeId) {
      try {
        const result = await request.get(
          '/interest/recharge-record/voucher-exists',
          {
            params: {
              // 保持字符串类型，避免含英文字母的哈希值被转换为数字。
              voucher: String(tradeId)
            },
            direct: true,
            validateStatus: () => true
          }
        )

        if (result && result.exists) {
          this.$alert('交易哈希值已存在，请勿重复提交', {
            confirmButtonText: this.$t('my25'),
            center: true,
            customClass: 'warning-alert',
            callback: () => {}
          })
          return false
        }
      } catch (error) {
        // 重复性检查接口异常时不阻断入金提交，最终结果由入金接口校验。
        // 这样可避免旧接口仅支持纯数字时，数字字母哈希无法提交。
        console.warn('交易哈希值重复性检查失败，将继续提交', error)
      }

      return true
    },
    async submitDeposit () {
      // 提交入金
      // if (this.rechargeInfo.bank_info.auth_status !== 2) {
      //   this.$confirm(this.$t('public37'), '', {
      //     confirmButtonText: this.$t('my25'),
      //     cancelButtonText: this.$t('my58'),
      //     customClass: 'warning-alert',
      //     type: 'warning'
      //   })
      //     .then(() => {
      //       if (this.userInfo.identity !== 0) {
      //         this.$router.push({ name: 'proxyInfo' })
      //       } else {
      //         this.$router.push({ name: 'userInfo' })
      //       }
      //     })
      //     .catch(() => {})
      //   return false
      // }
      if (
        this.depositData.amount < 0 ||
        this.depositData.amount === 0 ||
        !this.depositData.amount
      ) {
        this.$alert(this.$t('public30'), {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'warning-alert',
          callback: (action) => {}
        })
        return false
      }
      const tradeId = String(this.depositData.trade_id || '').trim()
      this.depositData.trade_id = tradeId

      this.isSubmitLoading = true

      try {
        const canSubmit = await this.checkRechargeVoucherExists(tradeId)
        if (!canSubmit) {
          return false
        }

        await this.$http.post('/api/cash/recharge', {
          ...this.depositData,
          exchange_rate: this.rechargeInfo.exchange_rate,
          wallet_type: this.currUsdtAddress.name,
          wallet_address: this.currUsdtAddress.address
        })

        this.$alert(
          `<h3>${this.$t('my23')}</h3><p>${this.$t('my24')}</p>`,
          '',
          {
            confirmButtonText: this.$t('my25'),
            center: true,
            dangerouslyUseHTMLString: true,
            customClass: 'success-alert',
            callback: () => {
              this.$router.push({ name: 'publicDepositRecord' })
            }
          }
        )
      } catch (error) {
      } finally {
        this.isSubmitLoading = false
      }
    }
  },
  computed: {
    usdMoney () {
      if (!this.rechargeInfo.exchange_rate || !this.depositData.amount) {
        return 0
      }
      const val = this.rechargeInfo.exchange_rate * this.depositData.amount
      return this.getBit(val, 5)
    },
    ...mapState(['userInfo'])
  }
}
</script>
<style scoped lang="scss">
.page-view {
  padding-top: 50px;
  padding-bottom: 100px;

  .box-card-header {
    width: 936px;
    margin: 0 auto;
    display: flex;
    justify-content: end;

    .kg-btn1 {
      width: 188px;
      margin-right: -6px;
      margin-bottom: 3px;
    }
  }

  .box-card-content {
    background: url("../../../assets/img/k.png") no-repeat center / 100%;
    width: 936px;
    height: 640px;
    margin: 0 auto;

    .reset-from {
      display: flex;

      .left {
        padding-top: 93px;
        padding-left: 95px;
        padding-right: 85px;
      }
      .right {
        .vs-info {
          width: 368px;
          height: 178px;
          margin-top: 30px;
          background: url("../../../assets/img/bg/dep-bg2.png") no-repeat center /
            100% 100%;
          .title {
            font-size: 18px;
            color: #fff;
            padding-top: 8px;
            padding-left: 10px;
          }
          .desc {
            font-size: 16px;
            color: #fff;
            line-height: 30px;
            padding: 20px;
            opacity: 0.8;
          }
        }
      }
      .bank-info {
        position: relative;
        width: 368px;
        height: 326px;
        margin-top: 56px;
        background: url("../../../assets/img/bg/dep-bg1.png") no-repeat center /
          100% 100%;

        .item-radio {
          margin-bottom: 30px !important;
        }

        ::v-deep .el-radio__inner {
          background: #000;
          width: 20px;
          height: 20px;
          border: 1px solid rgba(1, 178, 245, 0.5);
        }

        ::v-deep .el-radio__label {
          color: #fff;
        }

        ::v-deep .el-radio__input.is-checked .el-radio__inner {
          border: 4px solid #01b2f5;

          &::after {
            display: none;
          }
        }

        .code-img {
          margin-top: 20px;
          width: 110px;
          height: 110px;
          border: 1px solid rgba(1, 178, 245, 0.5);
        }

        .bank-info-title {
          font-size: 18px;
          font-weight: bold;
          color: #ffffff;
          display: block;
          height: 40px;
          line-height: 40px;
          padding-left: 15px;
          margin-bottom: 20px;
        }

        .info-item {
          display: flex;
          justify-content: space-between;
          padding-left: 14px;
          padding-right: 32px;
          margin-bottom: 6px;

          .info-item-left {
            .key {
              font-size: 14px;
              color: #01b2f5;
              line-height: 18px;
            }

            .value {
              font-size: 16px;
              color: #ffffff;
            }
          }

          .info-item-right {
            &.kg-btn4 {
              min-width: 69px;
              height: 38px;
              line-height: 38px;
            }
          }
        }
      }

      .form-item {
        margin-bottom: 35px;

        .form-item-label {
          font-size: 16px;
          font-weight: 400;
          color: #01b2f5;
        }

        .form-item-value {
          font-size: 18px;
          font-weight: bold;
          color: #ffffff;
        }
      }

      ::v-deep .el-form-item {
        margin-bottom: 40px;

        .el-form-item__label {
          font-size: 16px;
          font-family: Arial;
          font-weight: 400;
          color: #01b2f5;
        }

        .el-input__inner {
          width: 329px;
          height: 34px;
          border: 1px solid rgba(1, 178, 245, 0.5);
          line-height: 34px;
          background: transparent;
          color: #fff;
          border-radius: 0;
        }
      }

      .btn-submit {
        width: 110px;
        height: 55px;
        line-height: 55px;
        margin-left: -10px;
      }
    }
  }
}

.rate-text {
  padding-top: 12px;
  padding-left: 10px;
  font-size: 12px;
  font-weight: 400;
  color: #c9c9c9;
  line-height: 15px;

  i {
    font-size: 14px;
    font-weight: bold;
    color: #01b2f5;
  }
}

.btn-copy {
  display: inline-block;
  margin-left: 10px;
  text-decoration: underline;
  cursor: pointer;
}

@media only screen and (max-width: 755px) {
  .page-view {
    padding-top: 50px;
    padding-bottom: 100px;

    .box-card-header {
      width: auto;
      margin: 0 auto;
      display: flex;
      justify-content: end;

      .kg-btn1 {
        width: 238px;
        margin-right: -6px;
        margin-bottom: 3px;
      }
    }

    .box-card-content {
      background: none;
      width: auto;
      height: auto;
      margin: 0 auto;

      .reset-from {
        display: flex;

        .left {
          padding-top: 0;
          padding-left: 0;
          padding-right: 20px;
        }

        .bank-info {
          position: relative;
          width: 368px;
          height: 400px;
          background: url("../../../assets/img/xxbg.png") no-repeat center /
            100% 100%;

          .bank-info-title {
            font-size: 20px;
            font-weight: bold;
            color: #ffffff;
            display: block;
            height: 40px;
            line-height: 40px;
            padding-left: 15px;
            margin-bottom: 30px;
            padding-top: 10px;
          }

          .info-item {
            display: flex;
            justify-content: space-between;
            padding-left: 14px;
            padding-right: 32px;
            margin-bottom: 20px;

            .info-item-left {
              .key {
                font-size: 20px;
                color: #01b2f5;
                line-height: 18px;
                display: block;
                margin-bottom: 5px;
              }

              .value {
                font-size: 20px;
                display: block;
                color: #ffffff;
              }
            }

            .info-item-right {
              &.kg-btn4 {
                width: 90px;
                height: 38px;
                font-size: 18px;
                line-height: 38px;
              }
            }
          }
        }

        .form-item {
          margin-bottom: 35px;

          .form-item-label {
            font-size: 20px;
            font-weight: 400;
            color: #01b2f5;
          }

          .form-item-value {
            font-size: 20px;
            font-weight: bold;
            color: #ffffff;
          }
        }

        ::v-deep .el-form-item {
          margin-bottom: 40px;

          .el-form-item__label {
            font-size: 20px;
            font-family: Arial;
            font-weight: 400;
            color: #01b2f5;
          }

          .el-input__inner {
            width: 329px;
            height: 60px;
            font-size: 18px;
            border: 1px solid rgba(1, 178, 245, 0.5);
            line-height: 60px;
            background: transparent;
            color: #fff;
            border-radius: 0;
          }

          .el-form-item__error {
            font-size: 16px;
          }
        }

        .btn-submit {
          width: 210px;
          height: 85px;
          line-height: 85px;
          font-size: 20px;
          margin-left: -10px;
        }
      }
    }
  }

  .rate-text {
    padding-top: 12px;
    padding-left: 10px;
    font-size: 16px;
    font-weight: 400;
    color: #c9c9c9;
    line-height: 15px;

    i {
      font-size: 16px;
      font-weight: bold;
      color: #01b2f5;
    }
  }
}
</style>
